export default "__VITE_ASSET__96049a3d__"